import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { LeafIcon, ShieldIcon, SparkleIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { TrustSeals } from './TrustSeals';
import { checkoutUrl, images } from '../data/landing';
export function Hero() {
  const reduce = useReducedMotion();
  return <header className="relative overflow-hidden bg-gradient-to-b from-forest-deep via-forest to-[#6f9573] pb-12 pt-8 lg:bg-gradient-to-br lg:pb-20 lg:pt-12" data-id="element-28" data-mp="4n9zsnvorq5t">
      {/* Decoraciones */}
      <div aria-hidden="true" className="pointer-events-none absolute inset-0" data-id="element-29" data-mp="xbfht2vcv11y">
        <div className="absolute -left-20 top-24 h-64 w-64 rounded-full bg-sage/25 blur-3xl" data-id="element-30" data-mp="sai4b3laiv6s" />
        <div className="absolute -right-16 bottom-10 h-72 w-72 rounded-full bg-gold/20 blur-3xl" data-id="element-31" data-mp="ncq1vfn0rqoc" />
        <LeafIcon className="absolute -left-4 top-40 h-24 w-24 -rotate-12 text-sage/20" strokeWidth={1} data-id="element-32" data-mp="3d21uc37gquqd" />
        <LeafIcon className="absolute right-2 top-10 h-16 w-16 rotate-45 text-sage/20" strokeWidth={1} data-id="element-33" data-mp="3825yir8x69lw" />
        <ShieldIcon className="absolute bottom-24 left-6 h-14 w-14 text-gold/15" strokeWidth={1} data-id="element-34" data-mp="3j893b0s41pjq" />
        <SparkleIcon className="twinkle absolute right-10 top-32 h-5 w-5 text-gold-light" data-id="element-35" data-mp="3o7vhbcfrj9tl" />
        <SparkleIcon className="twinkle absolute left-10 top-16 h-3 w-3 text-gold-light [animation-delay:1.2s]" data-id="element-36" data-mp="39b4ip5dwy251" />
        <SparkleIcon className="twinkle absolute bottom-40 right-1/4 h-4 w-4 text-gold-light [animation-delay:2s]" data-id="element-37" data-mp="3e8ehvcr3ts62" />
      </div>

      <div className="relative mx-auto grid max-w-6xl items-center gap-8 px-5 lg:grid-cols-[1.05fr_1fr] lg:gap-14 lg:px-8" data-id="element-38" data-mp="30gq5d8cy11ok">
        <div className="text-center lg:text-left" data-id="element-39" data-mp="2qjv8sv08dbcx">
          <p className="mb-5 flex items-center justify-center gap-2 font-serif text-lg italic text-gold-light lg:justify-start" data-id="element-40" data-mp="2ql68ojqk1yyr">
            <ShieldIcon className="h-5 w-5" strokeWidth={1.75} aria-hidden="true" data-id="element-41" data-mp="2vgu25bc2lea2" />
            Sus defensas inician en casa
          </p>
          <h1 className="font-serif text-[2.1rem] font-semibold leading-[1.12] text-cream sm:text-5xl lg:text-[3.4rem]" data-id="element-42" data-mp="2lla5gmpombk9">
            Las defensas de tu hijo inician desde casa, con{' '}
            <span className="text-gold-light" data-id="element-43" data-mp="nbl2wm6daiaz">EL ESCUDO DE MAMÁ</span>
          </h1>
          <p className="mx-auto mt-5 max-w-xl text-base leading-relaxed text-cream/85 sm:text-lg lg:mx-0" data-id="element-44" data-mp="n9i71lij9uyc">
            Elimina ese ciclo infinito de mocos con esta guía práctica y programa
            para elevar las defensas de los niños desde la alimentación y los
            hábitos del hogar.
          </p>

          <div className="mt-8 hidden lg:block" data-id="element-45" data-mp="1622idp26vhee">
            <CtaButton href={checkoutUrl} data-id="element-46" data-mp="162c7zbjbnmjk">Quiero El Escudo de Mamá</CtaButton>
            <div className="mt-4 [&_ul]:justify-start" data-id="element-47" data-mp="111okv0y7rpum">
              <TrustSeals tone="light" data-id="element-48" data-mp="x14ohzlgsq9j" />
            </div>
          </div>
        </div>

        <div className="relative mx-auto w-full max-w-[420px] lg:max-w-[500px]" data-id="element-49" data-mp="x37falufynfb">
          <div aria-hidden="true" className="absolute inset-x-8 bottom-0 h-10 rounded-full bg-forest-deep/50 blur-2xl" data-id="element-50" data-mp="3lu9vowr7fq94" />
          <motion.div animate={reduce ? undefined : {
          y: [0, -12, 0],
          rotate: [0, 0.6, 0]
        }} transition={{
          duration: 5,
          repeat: Infinity,
          ease: 'easeInOut'
        }} className="relative overflow-hidden rounded-[28px] shadow-lift ring-1 ring-gold/50" data-id="element-51" data-mp="3htpyjt6msmmz">
            <img src={images.mainCover} alt="Mockup de la guía digital El Escudo de Mamá" className="block aspect-square w-full object-cover" data-id="element-52" data-mp="2b0pnv6mn30j3" />
          </motion.div>
        </div>

        
      </div>
    </header>;
}